export const mainServiceURL = import.meta.env.VITE_MAIN_SERVICE_URL || '';

export const gatewayURL = `${mainServiceURL}/gateway`;

export const mixgeniePath = '/mixgenie-service';
export const mixgenieServiceURL = `${gatewayURL}${mixgeniePath}`;

// Public (unauthenticated) gateway — used for endpoints that don't need a
// logged-in user, e.g. the presets catalog surfaced in the Generator picker.
export const publicGatewayURL = `${mainServiceURL}/public-gateway`;
export const mixgeniePublicServiceURL = `${publicGatewayURL}${mixgeniePath}/public`;
